import { Table } from 'antd';
import { TablePaginationConfig, ColumnGroupType, ColumnType, ColumnProps, ColumnsType } from 'antd/lib/table';
import React from 'react';
import style from './index.module.scss';
import Icon from '@ant-design/icons/es/components/Icon';
import Loading2 from './loading';
import classnames from 'classnames/bind';
import ResizeTable from './ResizeTable';
const LoadingIcon = (props) => {
    let afterProps = {
        className: props.className,
    };
    return React.createElement(Loading2, Object.assign({}, afterProps));
};
let loading = {
    tip: '正在加载中，请稍等...',
    indicator: React.createElement(Icon, { spin: true, component: LoadingIcon }),
};
let SiriusTable = (props) => {
    let { resizable = false, headerBgColor = true } = props;
    if (resizable) {
        return (React.createElement(ResizeTable, Object.assign({}, props, { loading: props.loading ? loading : false, rowClassName: (_, index) => (index % 2 === 1 ? 'odd' : 'even'), className: classnames([style.siriusTable, props.className]) })));
    }
    return (React.createElement(Table, Object.assign({ rowClassName: (_, index) => (index % 2 === 1 ? 'odd' : 'even') }, props, { loading: props.loading ? loading : false, className: classnames([style.siriusTable, props.className, headerBgColor ? style.headerBgColor : '']) })));
};
export { TablePaginationConfig, ColumnGroupType as TableColumnGroupType, ColumnType as TableColumnType, ColumnProps as TableColumnProps, ColumnsType as TableColumnsType, };
export default SiriusTable;
